import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { OrderCustomerListResponseDto } from "@/api/dtos";
import type { OrderCustomer } from "./_models/Customer";

/** Our customers that have orders, each with its order count (GET /customers, Postgres; not Cin7). */
export const getOrderCustomerListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getOrderCustomerList: builder.query<OrderCustomer[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<OrderCustomerListResponseDto>(
            `${backendBase()}/customers`,
            { headers: { Accept: "application/json" } },
          );
          const customers = res.data.customers.map((x) => ({ id: x.id, name: x.name, orderCount: x.orderCount }));
          return { data: customers };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
    }),
  }),
});

export const getOrderCustomerList = getOrderCustomerListApi.endpoints.getOrderCustomerList;
